import { CollectionView } from 'backbone.marionette';
import FixturesStatRow from '../FixturesStatRow';

export class FixturesStatsTable extends CollectionView {
	get childView() {
		return FixturesStatRow;
	}
}

export default FixturesStatsTable;